import { useMemo } from 'react';
import { ALLOW_ACCESS_CONTEXT_DEMO, hasPermission } from '@common/api/permission';
import useAccessRights from '@common/hooks/useAccessRights';
import { useFeatureFlag } from '@common/store/reducers/featureFlags';

const useEulaRequirement = (): boolean | undefined => {
  const { currentUser, isAdvancedUser } = useAccessRights();
  const enforceEula = useFeatureFlag('EnforceEula');

  return useMemo(
    () => (
      enforceEula
      && currentUser
      && isAdvancedUser
      && !hasPermission(currentUser, ALLOW_ACCESS_CONTEXT_DEMO)
      && !currentUser.hasAcceptedEula
    ),
    [currentUser, enforceEula, isAdvancedUser],
  );
};

export default useEulaRequirement;
